import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import _ from 'lodash';
import RequestManager from '../../../requests/RequestManager';
import FormValidations from '../../../data/FormValidations';
import * as actions from '../../../actions/response';
import CustomInputClaro from '../../forms/CustomInputClaro';
import * as constants from '../../../constants';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';
import * as actionsCard from '../../../action-creators/card';
import { converter } from '../../../helpers/converter';
import CheckControlPinTask from '../../../requests/tasks/user/controlPin/CheckControlPinTask';
import { createSearchParams } from 'react-router-dom';

class ModalPin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        pin: '',
      },
      errors: {},
    };

    this.setFormState = this.setFormState.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.isValidForm = this.isValidForm.bind(this);
    this.validatePIN = this.validatePIN.bind(this);
  }

  closeModal() {
    this.props.closeModal('Email');
  }

  isValidForm() {
    let formValid = true;
    this.state.errors = {};

    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.pin, 'pin')
        .validateMaxLongitude(6, 'Debes ingresar un PIN máximo de seis dígitos')
        .getErrors(),
    );
    converter.convertApaUnicode(this.props.translations, '');

    Object.assign(
      this.state.errors,
      new FormValidations(this.state.form.pin, 'pin')
        .validateMinLongitude(1, 'Debes ingresar un PIN mínimo de seis dígitos')
        .getErrors(),
    );

    if (Object.keys(this.state.errors).length !== 0) {
      formValid = false;
    }

    this.setState({ errors: this.state.errors });
    return formValid;
  }

  redirectToPayment(button) {
    const { extradata } = this.props;
    if (extradata) {
      const addPath = extradata.selectedOfferid
        ? `?offer_id=${this.props.extradata.selectedOfferid}`
        : '?o=Perfil';
      this.props.navigate(`${this.props.location.pathname}${addPath}`);
    } else {
      const groupResult = this.props.groupResult;
      const urlsPlayers = this.props.config.urlPlayer;
      const urlPlayer = this.getUrlPlayer(groupResult, urlsPlayers);
      const oneofferdesc = button.oneofferdesc;
      let rentParam = '';
      const queryParams = this.getQueryParams(groupResult, urlPlayer, button);
      if (button.linkworkflowstart) {
        queryParams.linkworkflowstart = button.linkworkflowstart;
      }
      const offerId = _.get(button, 'offerid', false);
      if (offerId) queryParams.offer_id = offerId;

      if (oneofferdesc.indexOf('24') > -1) {
        rentParam = '24';
      }

      if (oneofferdesc.indexOf('48') > -1) {
        rentParam = '48';
      }

      if (button.oneoffertype === 'download_buy') {
        rentParam = 'compra';
      }

      if (button.oneoffertype && button.oneoffertype.indexOf('event') !== -1) {
        rentParam = 'event_live';
      }

      if (button.oneoffertype !== 'subscrition') {
        const genres = _.get(groupResult, ['extendedcommon', 'genres']);
        queryParams.isrent = rentParam;
        queryParams.offertype = button.oneoffertype;
        queryParams.genero = _.get(genres, ['genre', '0', 'desc']);
      }

      if (window.self !== window.top) {
        window.parent.location = `${
          document.location.origin
        }/${constants.GetRegion()}/payment?${this.convertObjectToQuery(
          queryParams,
        )}`;
      } else {
        this.props.navigate(`/${constants.GetRegion()}/payment`, {
          search: `?${createSearchParams(queryParams)}`,
          state: { pin: this.state.form.pin },
        });
      }
      this.closeModal();
    }
  }

  convertObjectToQuery(query) {
    return Object.keys(query)
      .map(q => `${q}=${query[q]}`)
      .join('&');
  }

  getUrlPlayer(groupResult, urlsPlayers) {
    if (groupResult) {
      return ClaroUrlBuilder.player(groupResult.id);
    }
    return ClaroUrlBuilder.player(this.props.item.id);
  }

  getQueryParams(groupResult, urlPlayer, button) {
    if (groupResult) {
      return {
        group_id: groupResult.id,
        offer_id: button.offerid,
        player_url: urlPlayer,
        oneoffertype: button.oneoffertype,
        oneofferdesc: button.oneofferdesc,
        titleUri: _.get(groupResult, ['title_uri'], ''),
        price: _.get(button, ['price'], ''),
      };
    }
    return {
      player_url: urlPlayer,
      oneoffertype: button.oneoffertype,
      oneofferdesc: button.oneofferdesc,
      title: this.props.item.title,
    };
  }

  validatePIN(event) {
    event.preventDefault();
    if (!this.isValidForm()) {
      return;
    }

    const request = new CheckControlPinTask(this.props.config, {
      controlPIN: this.state.form.pin,
      userId: this.props.user.user_id,
    });
    RequestManager.addRequest(request)
      .then(data => {
        if (data) {
          this.props.setPin(this.state.form.pin);
          this.closeModal();
          this.redirectToPayment(this.props.button);
        }
      })
      .catch(e => {
        const { translations } = this.props;
        const message = converter.convertApaUnicode(
          translations,
          'profile_pin_modal_code_invalid',
          'El PIN no es correcto. Inténtalo nuevamente',
        );
        this.setState({ errors: { ...this.state.errors, pin: message } });
      });
  }

  setFormState(event) {
    this.state.form[event.target.name] = event.target.value;
    return this.setState({ form: this.state.form });
  }

  redirectRecoverPin() {
    window.parent.location = this.props.hrefMyAccount;
  }

  render() {
    const recoverPin = this.props.hrefMyAccount;
    const closeButtonClass = 'close close-modal';
    const buttonContinueClass = 'btn btn-primary btn-lg btn-block';
    return (
      <Modal show>
        <Modal.Header>
          <Button className={closeButtonClass} onClick={this.closeModal}>
            x
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginTop: '30px', textAlign: 'center' }}>
            <h2 className="modal-title">
              {converter.convertApaUnicode(
                this.props.translations,
                'pay_code_title',
              )}
            </h2>
            <p>
              {converter.convertApaUnicode(
                this.props.translations,
                'pay_code_enabled_hint',
              )}
            </p>
          </div>
          <form className="form-paso1" onSubmit={this.validatePIN}>
            <CustomInputClaro
              idElement="pin"
              inputType="password"
              labelText={converter.convertApaUnicode(
                this.props.translations,
                'pay_code_enter_pin',
              )}
              placeholderText={converter.convertApaUnicode(
                this.props.translations,
                'pay_code_enter_pin_hint',
              )}
              onChange={this.setFormState}
              value={this.state.form.pin}
              error={this.state.errors.pin}
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          {recoverPin && (
            <div
              className="col-lg-6 col-md-6 col-xs-12 col-sm-12"
              style={{ float: 'left', marginTop: '30px', textAlign: 'center' }}
            >
              <a onClick={this.redirectRecoverPin.bind(this)}>
                Recupera tu PIN
              </a>
            </div>
          )}
          <div
            className="col-lg-6 col-md-6 col-xs-12 col-sm-12"
            style={{ float: 'right', marginTop: '20px' }}
          >
            <div className="form-group">
              <input
                type="submit"
                onClick={this.validatePIN}
                className={buttonContinueClass}
                value="Aceptar"
              />
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalPin.propTypes = {
  translations: PropTypes.object,
  hrefMyAccount: PropTypes.string,
  button: PropTypes.object,
  config: PropTypes.object,
  user: PropTypes.object,
  item: PropTypes.object,
  closeModal: PropTypes.func,
  extradata: PropTypes.shape({}),
  groupResult: PropTypes.object,
  nodeId: PropTypes.string,
  setPin: PropTypes.func,
};

const mapStateToProps = state => ({
  modal: state.modal,
  config: state.config,
  user: state.user,
  translations: state.translations,
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
  setPin(pin) {
    dispatch(actionsCard.setPin(pin));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalPin);
